import { get } from "../../utils/objectHelpers";

$ {
    const title = get(input, "title", {});
    const sections = get(input, "sections", []);
}

<div class="str-business-details">
     <h2 class="str-business-details__title">
        <str-textual-display ...title />
    </h2>
    <div class="str-business-details__seller-info">
        <for|section| of=sections>
            <if(section.action)>
                <str-textual-display ...section.title action=section.action/>
            </if>
            <else>
                <str-textual-display ...section.title/>
            </else>
        </for>
    </div>
</div>
